import { userInitSelectors } from '@box/redux/authentication';
import { useAppSelector } from '@box/redux/hooks';

export const useIsAuthorized = () => {
  const isLogged = useAppSelector(userInitSelectors.isLogged);

  return { isLogged };
};
